import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SLOT_HEIGHT } from './calendarConstants';

const WeekSchedulerSlot = ({ date, dayIndex, slotIdx, onSlotClick, children }) => {
  const slotId = `slot-${dayIndex}-${slotIdx}`;
  const { setNodeRef, isOver } = useDroppable({
    id: slotId,
    data: {
      type: 'time-slot',
      dayIndex,
      slotIdx,
      date,
    },
  });

  const isHourRow = slotIdx % 2 === 0;

  const baseClass =
    'box-border relative ' +
    (isHourRow
      ? 'border-b border-gray-200 bg-white'
      : 'border-b border-dashed border-gray-100 bg-white');

  return (
    <div
      ref={setNodeRef}
      className={baseClass}
      style={{ height: SLOT_HEIGHT, cursor: 'pointer' }}
      onClick={() => onSlotClick?.(date, slotIdx)}
    >
      {isOver && (
        <div className="absolute inset-0 bg-[rgba(242,107,29,0.18)] pointer-events-none z-40" />
      )}
    </div>
  );
};

export default WeekSchedulerSlot;
